import { render } from "./PatientInsurances.vue?vue&type=template&id=01883bdc&scoped=true"
import script from "./PatientInsurances.vue?vue&type=script&lang=js"
export * from "./PatientInsurances.vue?vue&type=script&lang=js"

import "./PatientInsurances.vue?vue&type=style&index=0&id=01883bdc&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01883bdc"]])

export default __exports__